import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { UserSessionModel } from '../models/user-session.model';

export class UserSessionsApiService extends ApiService {
  static endpoint = 'auth/user-sessions';

  /**
   * @param {number | null} userSessionId
   * @returns {string}
   * @protected
   */
  static buildUserSessionUrl(userSessionId = null) {
    return this.buildUrl(userSessionId);
  }

  /**
   * @param {string | number} userSessionId
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise<ApiResponse<UserSessionModel>>}
   * @public
   */
  static async get(userSessionId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildUserSessionUrl(userSessionId), {
      ...config,
      dataModel: UserSessionModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {builderCallback|null} builderCallback
   * @param {object} config
   * @returns {Promise<ApiResponse<UserSessionModel>>}
   * @public
   */
  static getAll(builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildUserSessionUrl(), {
      ...config,
      dataModel: UserSessionModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {object} data
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise<ApiResponse<UserSessionModel>>}
   * @public
   */
  static async post(data, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildUserSessionUrl(), data, {
      ...config,
      dataModel: UserSessionModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {string | number} userSessionId
   * @param {object} data
   * @param {builderCallback} builderCallback
   * @param {object} config
   * @returns {Promise<ApiResponse<UserSessionModel>>}
   * @public
   */
  static async patch(userSessionId, data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.patch(this.buildUserSessionUrl(userSessionId), data, {
      ...config,
      dataModel: UserSessionModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {string | number} userSessionId
   * @param {object} config
   * @returns {Promise<HttpResponse>}
   * @public
   */
  static async delete(userSessionId, config = {}) {
    return HttpApiClient.delete(this.buildUserSessionUrl(userSessionId), { ...config });
  }
}
